import React from 'react';
import { Alert, Button, Skeleton, Typography } from '@mui/material';
import { AccountBalanceWalletOutlined, CheckCircleOutline, ArrowForward } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import useCommonGetInit from '../hooks/useCommonGetInit';
import { API_ENDPOINT } from '../../constants/constants';
import { money } from './paymentFormatting';

const TransactionReportCards = ({ type }) => {
  const { data, isLoading, isError, refetch } = useCommonGetInit(`${API_ENDPOINT}admin/settlement-stats?type=${type}`);
  const cards = [
    { title: 'Awaiting settlement', amount: data?.toSettle?.amount, icon: AccountBalanceWalletOutlined, caption: type === 'order' ? 'Sericulture order payments' : 'Cocoon payments', to: `/home/transactions?id=1&type=${type}`, action: 'Open settlement queue', accent: 'peach' },
    { title: 'Paid out', amount: data?.settled?.amount, icon: CheckCircleOutline, caption: 'All payment categories · all time', to: `/home/transactions?id=2&type=${type}`, action: 'View payout history', accent: 'green' },
  ];
  return <>
    {isError && <Alert severity="warning" sx={{ mb: 2 }} action={<Button color="inherit" size="small" onClick={refetch}>Retry</Button>}>Payment summaries are unavailable.</Alert>}
    <section className="payments-summary" aria-label="Payment summaries">{cards.map(({ title, amount, icon: Icon, caption, to, action, accent }) => <div className={`payments-summary-card ${accent}`} key={title}>
      <div className="payments-summary-top"><span className="payments-summary-icon"><Icon /></span><Typography component="h2" variant="body2" fontWeight={700}>{title}</Typography></div>
      <div className="payments-summary-value">{isLoading ? <Skeleton width="60%" height={48} /> : isError ? '—' : money(amount)}</div>
      <div className="payments-summary-bottom"><span>{caption}</span><Button component={Link} to={to} size="small" endIcon={<ArrowForward fontSize="small" />}>{action}</Button></div>
    </div>)}</section>
  </>;
};
export default TransactionReportCards;
